import React from "react";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { NumericFormat } from "react-number-format";
import { GetDateLocal } from "../../shared/utilitties/formatDate";
import { usePresentacionContext } from "../context/presentacion.context";
import ComprobantesDataTableTotales from "./ComprobantesDataTableTotales";
import {
  borrarFacturaPresentacion,
} from "../services/facturas.service";

import { FacturasIngresadaDTODelete } from "../adapters/factura.adapter";
import { isCombustibleAfines } from "../utilities/utils";
import { Tooltip } from "primereact/tooltip";
import ScanOCR_OK from "../../../images/SCAN_OK.svg";
import ScanOCR_MIX from "../../../images/SCAN_MIX.svg";
import ScanOCR_ERROR from "../../../images/SCAN_ERROR.png";
import { INICIADA_COMERCIO, RECHAZADA } from "../utilities/constants";

interface Props {
  onClick: Function;
  onClickEdit: Function;
  onClickMotivoRechazo: Function;
}

const ComprobantesOCRDataTable = (props: Props) => {
  const {
    comprobantes,
    updateComprobantes,
    setUpdateComprobantes,
    setMessage,
    spinnerComprobantes,
    setSpinnerComprobantes,presentacionEditable,
    transaccionesSeleccionadas,
    selectedProductoComercio, sumTSeleccionadas,
    presentacionState
  } = usePresentacionContext();
  
  const renderHeader = () => {
    return (
      <div className="p-grid p-justify-between p-align-center">
        <div className="p-col-12 p-md-6" style={{ textAlign: "left" }}>
        </div>
        <div className="p-col-12 p-md-6" style={{ textAlign: "end" }}>
          <div className="table-header-container">
            <div className="button-demo">
              <div className="template">
                <Button
                  className="p-0"
                  aria-label="Vimeo"
                  onClick={() => props.onClick("displayBasic2", "")}
                  style={{ background: 'linear-gradient(90deg, #F72717 0%, #FF007D 100%)' }}                
                  >
                    <img
                    src={ScanOCR_ERROR}
                    alt="DataScan"
                    title="DataScan"
                    style={{ width: 38, height: 38, objectFit: "contain", verticalAlign: "middle" }}
                    />
                  <span className="px-3">Ingresar a Data Scan</span>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const EliminarComprobante = async (rowData: any) => {
    setSpinnerComprobantes(true)
    let facturasIngresadaDTO = FacturasIngresadaDTODelete(rowData);
    //let facturaImagenDto = FacturaImagenDTO(fileName,fileBase64)
    let FacturasPresentacionRequest = {
      Factura: facturasIngresadaDTO,
      imagenFactura: {}
    };
    let resultBorrar = await borrarFacturaPresentacion(FacturasPresentacionRequest);
    if (resultBorrar.status === 200) {
      setUpdateComprobantes( updateComprobantes + 1);
      setSpinnerComprobantes(false)
      setMessage({
        life: 5000,
        severity: "success",
        summary: "Mensaje",
        detail: "Comprobante Eliminado.",
      });
    }
  };

  const actionBodyTemplate = (rowData: any) => {
    if(!presentacionEditable){
      return (
        <React.Fragment>
          <span className="p-column-title">Acciones</span>
          <Button
            className="p-button-rounded p-button-text"
            aria-label="Filter"
            onClick={() => props.onClickEdit(rowData)}
            tooltip="Ver Comprobante"
          >
            <i className="pi pi-eye mr-2"/>
          </Button>
        </React.Fragment>
      )
    }
    if(presentacionState === INICIADA_COMERCIO){
    return ( 
        <React.Fragment>
          <span className="p-column-title">Acciones</span>
          <Button
            className="p-button-rounded p-button-text"
            aria-label="Filter"
            onClick={() => props.onClickEdit(rowData)}
            tooltip="Ver Comprobante"
          >
            <i className="pi pi-eye mr-2"/>
          </Button>
          <Button
            className="p-button-rounded p-button-text"
            aria-label="Filter"
            onClick={() => EliminarComprobante(rowData)}
            tooltip="Eliminar"
          >
            <i className="pi pi-trash mr-2"></i>
          </Button>
        </React.Fragment>
      ) 
    }
    if(presentacionState === RECHAZADA){
    return ( 
        <React.Fragment>
          <span className="p-column-title">Acciones</span>
          <Button
            className="p-button-rounded p-button-text"
            aria-label="Filter"
            onClick={() => props.onClickEdit(rowData)}
            tooltip="Editar"
          >
            <i className="pi pi-pencil mr-2"/>
          </Button>
          <Button
            className="p-button-rounded p-button-text"
            aria-label="Filter"
            onClick={() => EliminarComprobante(rowData)}
            tooltip="Eliminar"
          >
            <i className="pi pi-trash mr-2"></i>
          </Button>
        </React.Fragment>
      ) 
    }
  };

  const fechaBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <span className="p-column-title">Fecha</span>
        {GetDateLocal(rowData.fac_fecha)}
      </React.Fragment>
    );
  };
  const formatPuntoDeVenta = (rowData: any) =>{
    return (
      <React.Fragment>
        {String(rowData.fac_sucursal).padStart(4, "0")}
        
      </React.Fragment>
    );
  }
  const formatNumeroFactura = (rowData: any) =>{
    return (
      <React.Fragment>
        {String(rowData.fac_numero).padStart(8,"0")}
        
      </React.Fragment>
    );
  }
  const setearMotivoRechazo = (rowData: any) => {
    const qty = 80;
    if (rowData.length > qty) {
      return ((rowData)?.substr(0, qty) + " ...");
    }
    else return rowData
  }
  const comprobanteTemplate = (rowData:any) => {
    const comprobante =`${rowData.fat_descripcion_red}-${rowData.fac_tipo_comprobante}-${ String(rowData.fac_sucursal).padStart(4, "0")}-${rowData.fac_numero.padStart(8,0)}`;
    return (
        <React.Fragment>
            <div style={{ alignContent: 'center' }} >
            {comprobante}
            </div>
        </React.Fragment>
    );
  }
  const motivoRechazoBodyTemplate = (rowData: any) => {
    return (
    <>
    <span className="p-column-title">type</span>
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
          {rowData.fpa_motivo_rechazo && rowData.fpa_motivo_rechazo !== "" && (
        <>
          <Tooltip target=".p-button-rounded" position="left" />
          <Button
            className="p-button-rounded p-button-outlined"
            data-pr-tooltip={setearMotivoRechazo(rowData.fpa_motivo_rechazo)}
            style={{ height: '1.5rem', border: 0 }}
            onClick={() => props.onClickMotivoRechazo(rowData)}>
            <i className="pi pi-exclamation-circle" style={{ color: 'red', fontSize: '1.5rem' }}></i>
          </Button>
        </>
      )}
      {rowData.fac_document_data_Id_OCR && (
        <img 
          src={rowData.fac_ingreso_manual ? ScanOCR_MIX : ScanOCR_OK} 
          alt="DataScan" 
          title={rowData.fac_ingreso_manual 
            ? "Este comprobante fue cargado con DataScan y modificado manualmente"
            : "Este comprobante fue cargado con DataScan y leído mediante IA"
          }
          style={{ width: 25, height: 25, objectFit: "contain" }} 
        />
      )}
    </div>
    
  </>
);
  };
  const formatMoneyBodyTemplate = (title: string, monto: any) => {
    return (
      <React.Fragment>
        {/*<span className="p-column-title">`${title}`</span>*/}
        <NumericFormat
          value={monto}
          displayType={"text"}
          thousandSeparator={"."}
          decimalSeparator={","}
          prefix={"$"}
          decimalScale={2}
          fixedDecimalScale={true}
        />
      </React.Fragment>
    );
  };

   const readOCR_Row = (rowData: any) => {
      return (
    <>
    <span className="p-column-title">type</span>
    {rowData.Fac_document_data_Id_OCR && (
      <img 
        src={rowData.fac_ingreso_manual ? ScanOCR_MIX : ScanOCR_OK} 
        alt="DataScan" 
        title="DataScan" 
        data-pr-tooltip={rowData.fac_ingreso_manual 
        ? "Este comprobante fue cargado con DataScan y modificado manualmente"
        : "Este comprobante fue cargado con DataScan y leído mediante IA"
      }
        style={{ width: 22, height: 22, objectFit: "contain", verticalAlign: "middle" }} 
      />
      )}
    </>
  );
  }
  return (
    <div className="card">
      
      <DataTable
        header={(presentacionEditable && (transaccionesSeleccionadas.length > 0 || sumTSeleccionadas) ) ? () => renderHeader() : <></>}
        value={comprobantes}
        responsiveLayout="stack"
        className="txDataTable"
        loading={spinnerComprobantes}
      >
        <Column
          field="fat_descripcion_red"
          header="Comprobante"
          style={{ width: "10%" }}
          body={comprobanteTemplate}
        />
        <Column
            field="fpa_motivo_rechazo"
            body={motivoRechazoBodyTemplate}
            style={{ width: "1%" }}
        ></Column>
        <Column
          field="fac_registracion"
          header="Fecha comprobante"
          body={fechaBodyTemplate}
          style={{ width: "10%" }}
        ></Column>
        <Column
          field="fac_neto"
          header="Importe neto"
          body={(rowData) => formatMoneyBodyTemplate("Neto", rowData.fac_neto)}
          style={{ textAlign: "right", width: "10%" }}
        />
        <Column
          field="fac_impuestos"
          header={isCombustibleAfines(selectedProductoComercio.grupoProductoId) ? "ITC/IDC/Tasas" : "Neto No Gravado"}
          body={(rowData) =>
            formatMoneyBodyTemplate("Imp", rowData.fac_impuestos)
          }
          style={{ textAlign: "right", width: "10%" }}
        />

        <Column
          field="fac_iva"
          header="IVA"
          body={(rowData) => formatMoneyBodyTemplate("IVA", rowData.fac_iva)}
          style={{ textAlign: "right", width: "10%" }}
        />
        <Column
          field="fac_iva_percepcion"
          header="IVA percepción"
          body={(rowData) =>
            formatMoneyBodyTemplate("IVA P.", rowData.fac_iva_percepcion)
          }
          style={{ textAlign: "right", width: "10%" }}
        />
        <Column
          field="fac_IIBB_percepcion"
          header="IIBB percepción."
          headerStyle={{textAlign: "center"}}
          body={(rowData) =>
            formatMoneyBodyTemplate("IIBB P.", rowData.fac_IIBB_percepcion)
          }
          style={{ textAlign: "right", width: "10%" }}
        />
        <Column
          field="fac_total"
          header=" Importe total"
          body={(rowData) =>
            formatMoneyBodyTemplate("Total", rowData.fac_total)
          }
          style={{ textAlign: "right", width: "10%" }}
        />
         {/* <Column
          rowEditor
          header="Data Scan"
          body={(rowData) =>
            readOCR_Row(rowData)
          }          style={{ textAlign: "right",  width: "1%" }}
        ></Column> */}
        <Column
          rowEditor
          header="Editar"
          body={actionBodyTemplate}
          style={{ width: "10%" }}
        ></Column>
      </DataTable>
      
      {comprobantes.length > 0 ? <ComprobantesDataTableTotales /> : <></>}
    </div>
  );
};

export default ComprobantesOCRDataTable;

